import React, { Component } from "react"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
})
const optionInstalmentDate = [
      { value: "0", label: "نقد" },
      { value: "1", label: "یک ماه بعد" },
      { value: "2", label: "دو ماه بعد" },
      { value: "3", label: "سه ماه بعد" },
      { value: "4", label: "چهار ماه بعد" },
      { value: "5", label: "پنج ماه بعد" },
      { value: "6", label: "شش ماه بعد" },
      { value: "7", label: "هفت ماه بعد" },
      { value: "8", label: "هشت ماه بعد" },
      { value: "9", label: "نه ماه بعد" },
      { value: "10", label: "ده ماه بعد" },
      { value: "11", label: "یازده ماه بعد" },
]

class InstalmentConditoin extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  conditionState: this.props.condition,
                  selectedInstalmentMode: {
                        value: this.props.condition.instalment_conditions_mode_id,
                        label: this.props.condition.instalment_mode_mode_name,
                  },
                  selectedInstalmentDate: optionInstalmentDate[parseInt(this.props.condition.instalment_conditions_date)],
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  optionInstalmentMode: [],
            }
      }
      componentDidMount() {
            this.getoptionInstalmentMode()
      }
      getoptionInstalmentMode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].instalment_mode_mode_id, label: arr.data[k].instalment_mode_mode_name })
                              }
                              self.setState({ optionInstalmentMode: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_instalment_mode")
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleInstalmentMode = (selectedInstalmentMode) => {
            var temparray = this.state.conditionState
            temparray.instalment_conditions_mode_id = selectedInstalmentMode.value
            this.setState({ selectedInstalmentMode: selectedInstalmentMode, conditionState: temparray })
      }

      handleInstalmentDate = (selectedInstalmentDate) => {
            var temparray = this.state.conditionState
            temparray.instalment_conditions_date = selectedInstalmentDate.value
            this.setState({ selectedInstalmentDate: selectedInstalmentDate, conditionState: temparray })
      }
      handleChangeConditionsPercent = (event) => {
            var temparray = this.state.conditionState
            temparray.instalment_conditions_percent = event.target.value
            this.setState({ conditionState: temparray })
      }

      handleChangeConditionsDesc = (event) => {
            var temparray = this.state.conditionState
            temparray.instalment_conditions_desc = event.target.value
            this.setState({ conditionState: temparray })
      }

      saveNewInstalmentCondition = () => {
            const { conditionState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_contract_instalment")
            fd.append("instalment_conditions_id", conditionState.instalment_conditions_id)
            fd.append("instalment_conditions_percent", conditionState.instalment_conditions_percent)
            fd.append("instalment_conditions_desc", conditionState.instalment_conditions_desc)
            fd.append("instalment_conditions_date", conditionState.instalment_conditions_date)
            fd.append("instalment_conditions_mode_id", conditionState.instalment_conditions_mode_id)

            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { conditionState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_contract_instalment")
            fd.append("instalment_conditions_id", conditionState.instalment_conditions_id)

            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const {
                  optionInstalmentMode,
                  snackMode,
                  snackstr,
                  showSnack,
                  visible,
                  selectedInstalmentDate,
                  selectedInstalmentMode,
                  conditionState,
            } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={6} sm={2}>
                                    <div>
                                          <label className="on"> نوع</label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"نوع تخفیف"}
                                                value={selectedInstalmentMode}
                                                onChange={this.handleInstalmentMode}
                                                options={optionInstalmentMode}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={6} sm={3}>
                                    <div>
                                          <label className="on"> زمان</label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"زمان"}
                                                value={selectedInstalmentDate}
                                                onChange={this.handleInstalmentDate}
                                                options={optionInstalmentDate}
                                          />
                                    </div>
                              </Grid>

                              <Grid item item xs={3} sm={2}>
                                    <FloatingLabelInput
                                          placeholder="درصد"
                                          handleInputt={this.handleChangeConditionsPercent}
                                          value={conditionState.instalment_conditions_percent}
                                    />
                              </Grid>
                              <Grid item item xs={5} sm={3}>
                                    <FloatingLabelInput
                                          placeholder="توضیحات"
                                          handleInputt={this.handleChangeConditionsDesc}
                                          value={conditionState.instalment_conditions_desc}
                                    />
                              </Grid>

                              <Grid item item xs={4} sm={2}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab style={{ background: "#44b700" }} aria-label="edit" onClick={this.saveNewInstalmentCondition}>
                                                <EditIcon />
                                          </Fab>

                                          <Fab color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default InstalmentConditoin
